import { setupWidget } from "./shared";

class FeraProductRating extends HTMLElement {
    connectedCallback() {
        setupWidget({window, document, element: this, tempHtml: this._tempHtml, tempCss: this._tempCss });
    }

    get _tempHtml() {
        return `<span class="fera-placeholder fera-stars">★★★★★</span>`;
    }

    get _tempCss() {
        return `.fera-placeholder.fera-stars {
    background: rgb(222 222 222);
    background: linear-gradient(90deg, rgb(138, 138, 138) 0%, rgba(255, 255, 255, 1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-position: 0% 0%;
    background-size: 200% 100%;
    font-size: initial;
    letter-spacing: 0.15em;
    animation: fera-placeholder-animation 1.5s ease-out -1.5s infinite alternate forwards;
}

@keyframes fera-placeholder-animation {
    0% {
        background-position: 0% 0%;
    }
    100% {
        background-position: 100% 0%;
    }
}

.fera-widget-placeholder h2,
.fera-widget-placeholder span,
.fera-widget-placeholder a,
.fera-widget-placeholder .circle {
    display: block;
    background: rgb(222, 222, 222);
    background: linear-gradient(90deg, rgb(215, 215, 215) 0%, rgba(255, 255, 255, 1) 100%);
    background-position: 0% 0%;
    background-size: 200% 100%;
    animation: fera-placeholder-animation 1.5s ease-out -1.5s infinite alternate forwards;
}
`;
    }
}

customElements.define("fera-product-rating", FeraProductRating);
